
<kendo-formfield>
    <kendo-label [text]="caption | translate"></kendo-label>
    <kendo-maskedtextbox
    [ngClass]="{'fx-fill': settings.fxFill}"  
    [formControl]="control" 
    (valueChange)="onChange($event)"
    (blur)="onBlur()"
    [mask]="settings.format"
    [maskValidation]="true"
    [includeLiterals]="true"
    [readonly]="settings.readonly"
    > </kendo-maskedtextbox>
</kendo-formfield>


